<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { Toast, Popup } from 'mint-ui'
import * as R from 'ramda'
import _ from 'underscore'

import { myIndicator } from '../../../components/my-indicator'
import Header from '../../../components/header.vue'
import Tabbar from '../../../components/tab-bar.vue'
import Icon from '../../../components/icon.vue'
import { isStopSelling, getDistanceBetween } from '../../../util/function'
import Banner from './banner'

import CinemaItem from './cinema_item.vue'

import cookie from '../../../lib/cookie'
import CCONSTANT from '../../../constant/cookie'

const FILTER_TYPE_IS_ALL = 'all'
const FILTER_TYPE_IS_DISTRICT = 'district'
const FILTER_DISTRICT_IS_ALL_CITY = '全城'
const FILTER_TYPE_IS_SPECIFY = 'specify'
const FILTER_TYPE_IS_SPECIFY_NEAREST = '离我最近'
const FILTER_TYPE_IS_SPECIFY_RECENTLY = '最近去过'
const IS_VISITED_CINEMA = 1
const FILTER_TYPE_DEFAULT = {
  type: FILTER_TYPE_IS_ALL,
  value: '',
}

let filterArray = [FILTER_TYPE_IS_SPECIFY_NEAREST, FILTER_TYPE_IS_SPECIFY_RECENTLY]

const STOP_SELLING_TIP = '当前场次已经停止售票，请选择其他场次。'

export default {
  data() {
    return {
      text: 'app film-cinema-view detail page',
      filmId: this.$route.params.id,
      isShowDistrictFilter: false,
      isShowSpecifyFilter: false,
      currentDate: 0,
      districtName: FILTER_DISTRICT_IS_ALL_CITY,
      specifyName: FILTER_TYPE_IS_SPECIFY_RECENTLY,
      districtFilter: FILTER_DISTRICT_IS_ALL_CITY,
      specifyFilter: FILTER_TYPE_IS_SPECIFY_RECENTLY,
    }
  },
  components: {
    'my-header': Header,
    'cinema-item': CinemaItem,
    [Popup.name]: Popup,
    Tabbar,
    Icon,
    Banner,
  },
  watch: {
    isShowDistrictFilter(nv, ov) {
      if (nv) {
        this.isShowSpecifyFilter = false
      }
    },
    isShowSpecifyFilter(nv, ov) {
      if (nv) {
        this.isShowDistrictFilter = false
      }
    },
    filmPremiereDate(nv, ov) {
      if (!R.isEmpty(nv)) {
        const id = R.sort((a, b) => a - b)(nv)[0]
        return this.handleDateChange(id)
      }
    },
    cinemaDetailList(nv, ov) {
      const visitedCinemas = R.filter(v => {
        return R.propEq('isVisited', IS_VISITED_CINEMA)(v)
      })(nv)
      // console.log('fetch visited cinema\'s schedule. ', visitedCinemas)
    },
  },
  computed: {
    ...mapGetters([
      'filmPremiereDate',
      'filmCinemaDetailListByDate',
      'filmCinemaIdsByDate',
      'filmCinemaVisited',
      'cityGetSelectedCity',
      'filmCinemaLowestPriceByCinemaId',
    ]),
    ...mapState({
      currentPosition: state => `${state.city.gps.latitude}:${state.city.gps.longitude}`,
      cinemaBanner: state => state.cinema.cinemaBanner,
    }),
    pageCinemaList() {
      let list = this.filmCinemaDetailListByDate(this.currentDate)
      return R.map(v => {
        return {
          ...v,
          distance:
            getDistanceBetween(v.gpsAddress, this.currentPosition) != '距离未知' ? `${getDistanceBetween(v.gpsAddress, this.currentPosition)}km` : '距离未知',
          lowPrice: this.filmCinemaLowestPriceByCinemaId(v.cinemaId),
        }
      })(list)
    },
    selected() {
      return this.cityGetSelectedCity
    },
    film() {
      return this.$store.state.film.filmInfo || {}
    },
    districts() {
      const ret = R.uniq(
        R.map(v => {
          return v.district.name
        })(this.pageCinemaList),
      )
      return [FILTER_DISTRICT_IS_ALL_CITY].concat(ret)
    },
    filterArray() {
      return [FILTER_TYPE_IS_SPECIFY_NEAREST, FILTER_TYPE_IS_SPECIFY_RECENTLY].concat(this.districts)
    },
    cinemaDetailList(vm) {
      const cinemaList = this.pageCinemaList
      let retList = cinemaList
      const dFilter = this.districtFilter
      const sFilter = this.specifyFilter
      // console.log('dfilter sfitler ', dFilter, sFilter)
      if (!(dFilter === FILTER_TYPE_IS_ALL || dFilter === FILTER_DISTRICT_IS_ALL_CITY)) {
        retList = R.filter(v => {
          return R.path(['district', 'name'])(v) == dFilter
        })(cinemaList)
      }
      retList = R.sortBy(a => {
        return parseFloat(a.distance)
      })(retList)
      // some preblem when using ramda in sortBy func, instead of _ .
      if (sFilter === FILTER_TYPE_IS_SPECIFY_RECENTLY) {
        retList = _.sortBy(retList, v => {
          return 0 - v.isVisited
        })
      }

      // 过滤 seatflag = 0 的影院
      const newRetList = _.filter(retList, v => {
        return v.seatFlag == 1
      })

      return newRetList
    },
  },
  methods: {
    ...mapActions(['getFilmCinemaDetailList', 'getCinemaBanner']),
    toSearch() {
      return this.$router.push({
        path: '/cinemas/search',
      })
    },
    handleDateChange(id) {
      const cinemaIds = this.filmCinemaIdsByDate(id)
      this.currentDate = id
      this.filter = {
        type: FILTER_TYPE_IS_ALL,
        value: '',
      }
      this.getFilmCinemaDetailList({
        date: id,
        cinemaIds,
        cityId: this.selected.cityId,
      })
        .catch(err => {
          console.log('err', err)
        })
        .finally(myIndicator())
    },
    generateK(cinemaId) {
      const k = String(this.filmId) + String(cinemaId) + String(this.currentDate)
      return k
    },
    toCinema(cinemaId) {
      const toPath = `/cinema/${cinemaId}/film/${this.filmId}/${this.currentDate}`
      return this.$router.push({
        path: toPath,
      })
    },
    toSeactchart(schedule) {
      if (isStopSelling(schedule.showAt, schedule.advanceStopMins)) {
        return Toast({
          message: STOP_SELLING_TIP,
          position: 'bottom',
          duration: 3000,
        })
      }
      return this.$router.push({
        path: `/schedule/${schedule.scheduleId}/${this.currentDate}`,
      })
    },
    toggleFilter(type) {
      if (type == 'district') {
        this.isShowDistrictFilter = !this.isShowDistrictFilter
      } else if (type == 'specify') {
        this.isShowSpecifyFilter = !this.isShowSpecifyFilter
      }
    },
    filterDistrict(name) {
      this.isShowDistrictFilter = !this.isShowDistrictFilter
      this.districtFilter = name
      this.districtName = name
    },
    filterNearest() {
      this.isShowSpecifyFilter = !this.isShowSpecifyFilter
      this.specifyFilter = FILTER_TYPE_IS_SPECIFY_NEAREST
      this.specifyName = FILTER_TYPE_IS_SPECIFY_NEAREST
    },
    filterRecently() {
      this.isShowSpecifyFilter = !this.isShowSpecifyFilter
      this.specifyFilter = FILTER_TYPE_IS_SPECIFY_RECENTLY
      this.specifyName = FILTER_TYPE_IS_SPECIFY_RECENTLY
    },
  },
  mounted() {
    this.$store.dispatch('getFilmInfo', {
      filmId: this.filmId,
    })
    this.$store
      .dispatch('getFilmCinemaList', {
        cityId: this.selected.cityId,
        filmId: this.filmId,
      })
      .then(data => {
        if (this.$route.query.date) {
          if (this.filmPremiereDate.indexOf(+this.$route.query.date) > -1) {
            this.handleDateChange(+this.$route.query.date)
            this.currentDate = +this.$route.query.date
          }

          //this.handleDateChange(+this.$route.query.date)
        }
        console.log(data)
      })
      .catch(err => {
        console.log(err)
      })
    this.getCinemaBanner(this.selected.cityId)
  },
}
</script>

<template>
  <div class="film-cinema-view">
    <my-header showBack>
      <span slot="title">{{ film.name }}</span>
      <div slot="right" @click="toSearch">
        <Icon :size="26">sousuo-sousuofangdajing</Icon>
      </div>
    </my-header>

    <Tabbar
      :fixPadding="true"
      :tabtitles="filmPremiereDate | date_format"
      :titleWidth="100"
      :defaultActiveId="currentDate == 0 ? +filmPremiereDate[0] : +currentDate"
      @changeTab="handleDateChange"
      class="dateWrap"
    ></Tabbar>
    <div class="filter">
      <div class="tab">
        <div :class="isShowDistrictFilter ? 'district active' : 'district'" @click="toggleFilter('district')">
          {{ districtName || '全城' }}
          <img src="../../../../image/cinema/shang.png" width="6px" height="3px" v-show="isShowDistrictFilter" />
          <img src="../../../../image/cinema/xia.png" width="6px" height="3px" v-show="!isShowDistrictFilter" />
        </div>
        <div :class="isShowSpecifyFilter ? 'specify active' : 'specify'" @click="toggleFilter('specify')">
          {{ specifyName || '最近去过' }}
          <img src="../../../../image/cinema/shang.png" width="6px" height="3px" v-show="isShowSpecifyFilter" />
          <img src="../../../../image/cinema/xia.png" width="6px" height="3px" v-show="!isShowSpecifyFilter" />
        </div>
      </div>
    </div>
    <mt-popup position="top" pop-transition="popup-fade" v-model="isShowDistrictFilter" class="area-box filter-box">
      <div class="filter-wrap">
        <ul class="district-list">
          <li v-for="v in districts" :key="v" data="v" @click="filterDistrict(v)">
            <div :class="{ selected: districtFilter == v }">{{ v }}</div>
          </li>
        </ul>
      </div>
    </mt-popup>
    <mt-popup position="top" pop-transition="popup-fade" v-model="isShowSpecifyFilter" class="area-box filter-box">
      <div class="filter-wrap">
        <ul class="filter-list">
          <li @click="filterRecently" :class="{ selected: '最近去过' == specifyFilter }">
            <img src="../../../../image/cinema/iconTick.png" width="13px" height="9px" v-if="'最近去过' == specifyFilter" alt />
            <span class="placehold" v-else style="width:13px;"></span>
            <span class="filter-text">最近去过</span>
          </li>
          <li @click="filterNearest" :class="{ selected: '离我最近' == specifyFilter }">
            <img src="../../../../image/cinema/iconTick.png" width="13px" height="9px" v-if="'离我最近' == specifyFilter" alt />
            <span class="placehold" v-else style="width:13px;"></span>
            <span class="filter-text">离我最近</span>
          </li>
        </ul>
      </div>
    </mt-popup>
    <!-- <div class="filter">
      <div class="tab">
        <div :class="isShowDistrictFilter ? 'district active' : 'district' " @click="toggleFilter('district')">
          {{ districtName || '全城' }}<Icon :size="10" v-show="isShowDistrictFilter">sousuo-paixujiantoushang</Icon><Icon :size="10" v-show="!isShowDistrictFilter">sousuo-paixujiantouxia</Icon>
        </div>
        <div :class="isShowSpecifyFilter ? 'specify active' : 'specify' " @click="toggleFilter('specify')">
          {{ specifyName || '最近去过' }}<Icon :size="10" v-show="isShowSpecifyFilter">sousuo-paixujiantoushang</Icon><Icon :size="10" v-show="!isShowSpecifyFilter">sousuo-paixujiantouxia</Icon>
        </div>
      </div>
      <div class="detail" v-show="isShowDistrictFilter || isShowSpecifyFilter">
        <div class="district-info clearfix" v-show="isShowDistrictFilter">
          <div v-for="v, i in districts" :class="districtFilter === v ? 'district-item active' : 'district-item'" @click="filterDistrict(v)">{{v}}</div>
        </div>
        <div class="specify-info" v-show="isShowSpecifyFilter">
          <div :class="specifyFilter === '最近去过' ? 'recently active' : 'recently'" @click="filterRecently">
            <Icon :size="10" class="tick" v-show="specifyFilter === '最近去过'">tick</Icon>最近去过
          </div>
          <div :class="specifyFilter === '离我最近' ? 'nearest active' : 'nearest'" @click="filterNearest">
            <Icon :size="10" class="tick"  v-show="specifyFilter === '离我最近'">tick</Icon>离我最近
          </div>
        </div>
      </div>
    </div>-->
    <Banner :banner="cinemaBanner"></Banner>
    <div class="cinema-list">
      <!-- <div class="mask" v-show="isShowDistrictFilter || isShowSpecifyFilter"></div> -->
      <cinema-item
        v-for="item in cinemaDetailList"
        :info="item"
        :key="item.cinemaId"
        @handleCinemaClick="toCinema(item.cinemaId)"
        @handleScheduleClick="toSeactchart"
        :cinemaId="String(item.cinemaId)"
        :filmId="String(filmId)"
        :date="String(currentDate)"
      ></cinema-item>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';
@battleshipGrey: rgb(121, 125, 130);
.film-cinema-view {
  background-color: #fff;
  min-height: 100vh;
  .mint-popup {
    top: calc(~'44px + 49px + 49px');
    z-index: 2998 !important;
  }
  .v-modal {
    background: rgba(0, 0, 0, 0.6);
    z-index: 1900 !important;
  }
  .filter-wrap {
    width: 100vw;
  }
  .district-list {
    list-style: none;
    padding: 10px 0 0 0;
    margin: 0 0 0 10px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    flex-wrap: wrap;
    li {
      font-size: 12px;
      display: inline-block;
      width: calc(~'(100vw - 50px)/4');
      padding-bottom: 15px;
      padding-right: 10px;
      height: 30px;
      flex-shrink: 1;
      div {
        position: relative;
        color: @battleshipGrey;
        border-radius: 3px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        &::after {
          .setBorderLine(rgba(210, 214, 220, 0.5));
        }
      }
      .selected {
        color: @orange;
        &::after {
          .setBorderLine(@orange);
        }
      }
    }
  }
  .filter-list {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      height: 44px;
      width: 100vw;
      padding: 0 15px;
      position: relative;
      color: @battleshipGrey;
      .filter-text {
        margin-left: 10px;
        font-size: 13px;
        letter-spacing: -0.2px;
        line-height: 44px;
      }
      .placehold {
        display: inline-block;
        width: 13px;
      }
      &::after {
        .setBottomLine();
      }
    }
    .selected {
      color: @orange;
    }
  }
  .filter {
    .tab {
      height: 49px;
      width: 100%;
      padding: 15px 0;
      position: relative;
      z-index: 2999;
      background-color: #fff;
      .district,
      .specify {
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: @darkGrey;
        float: left;
        width: 50%;
        i {
          margin-left: 6px;
        }
      }
      &:after {
        .setBottomLine();
      }
      img {
        vertical-align: middle;
        padding-left: 2px;
      }
    }
    .detail {
      position: relative;
      background-color: #fff;
      .district-info {
        width: 100%;
        padding: 7.5px 5px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        background-color: #fff;
        .district-item {
          float: left;
          height: 30px;
          width: 81px;
          margin: 7.5px 5px;
          color: @steelGrey;
          text-align: center;
          font-size: 13px;
          line-height: 30px;
          position: relative;
          &::after {
            .setBorderLine(@steelGrey);
          }
        }
        .active {
          position: relative;
          &::after {
            .setBorderLine(@orange);
          }
        }
      }
      .specify-info {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        background-color: #fff;
        .recently,
        .nearest {
          height: 44px;
          font-size: 13px;
          line-height: 18.5px;
          padding: 13px 0 13px 38px;
          color: @steelGrey;
          position: relative;
          &:after {
            .setBottomLine();
          }
          .tick {
            position: absolute;
            left: 0;
            padding-left: 15px;
          }
        }
      }
    }
    .active {
      color: @orange !important;
    }
  }
  .cinema-list {
    position: relative;
    .mask {
      height: 100%;
      background-color: rgb(0, 0, 0);
      opacity: 0.3;
      position: absolute;
      right: 0px;
      left: 0px;
      z-index: 1;
    }
  }
  .dateWrap {
    padding-top: 44px;
    z-index: 2999;
  }
}
</style>
